import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Button, PopUpTitles } from '../../model/enum';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AgGridI } from '../ag-grid/ag-grid.model';
import { AgGridUnmappedData } from '../../../components/crm/crm.model';
import { AgGridComponent } from '../ag-grid/ag-grid.component';

@Component({
  selector: 'app-unmapped-pop-up',
  templateUrl: './unmapped-pop-up.component.html',
  styleUrls: ['./unmapped-pop-up.component.scss']
})
export class UnmappedPopUpComponent implements OnInit {
  @Input() data :any;
  @ViewChild(AgGridComponent) grid!: AgGridComponent;

  enumPopUpTitles = PopUpTitles;
  enumButtonName = Button;
  agGriColumns !: AgGridI;
  gridApi: any;
  dynamicHeight = { 'height': '60vh' };
  gridColumnApi: any;
  constructor(
    public activeModal   : NgbActiveModal,
  ) { }

  ngOnInit(): void {
    this.agGriColumns = AgGridUnmappedData
  }
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    const rowData = this.data?.unmappedColumns || [];
    if (rowData.length > 0) {
      this.gridApi.setRowData(rowData);
    }
    if (this.grid) {
      this.grid.agGridPaginationConfig.rows = rowData;
      this.grid.agGridPaginationConfig.totalRecords = rowData.length;
    }
  }


}
